import { render, staticRenderFns } from "./WonderYjjRateML.vue?vue&type=template&id=15688cb5&scoped=true"
import script from "./WonderYjjRateML.vue?vue&type=script&lang=js"
export * from "./WonderYjjRateML.vue?vue&type=script&lang=js"
import style0 from "./WonderYjjRateML.vue?vue&type=style&index=0&id=15688cb5&prod&lang=css"
import style1 from "./WonderYjjRateML.vue?vue&type=style&index=1&id=15688cb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15688cb5",
  null
  
)

export default component.exports